import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as Common from '_common';
import * as Components from '_components';
import * as Styles from './Notifications.module.scss';
export function Notifications() {
    var events = useSortedNotifications();
    if (events.length === 0) {
        return _jsx(_Fragment, {});
    }
    return (_jsx("div", { style: { height: '25vh', marginBottom: 'var(--gap-main)', fontSize: '0.8em', position: 'relative' }, children: _jsxs(Components.Widget, { children: [_jsx(Components.WidgetComponent, { side: Components.WidgetComponentType.Top, type: Components.WidgetSideType.Big }), _jsx(Components.WidgetComponent, { side: Components.WidgetComponentType.Bottom, type: Components.WidgetSideType.Big }), _jsx(Components.WidgetComponent, { side: Components.WidgetComponentType.Content, children: _jsx("div", { className: Styles.notifications, children: events.map(function (ev) { return _jsx(Notification, { Name: ev.Code, Path: ev.Path, Created: ev.Timestamp, Parameters: ev.Params }, ev.key); }) }) })] }) }));
}
export function Notification(props) {
    function formatParemeters(value) {
        if (value === null) {
            return 'null';
        }
        if (value === true) {
            return 'true';
        }
        if (value === false) {
            return 'false';
        }
        return value;
    }
    return (_jsxs("div", { className: Styles.notification, children: [_jsx("span", { className: Styles.timestamp, children: props.Created }), _jsxs("p", { className: Styles.title, children: [props.Name, " - ", _jsx("small", { children: props.Path })] }), _jsx("div", { className: Styles.parameters, children: Object.keys(props.Parameters || {}).map(function (key) { return (_jsx(Components.Property, { title: key, children: formatParemeters(props.Parameters[key]) }, key)); }) })] }));
}
export function useSortedNotifications() {
    var context = Common.useSpaContext();
    var events = (context === null || context === void 0 ? void 0 : context.events) || {};
    var list = {};
    for (var service in events) {
        var event_2 = Object.keys(events[service] || {});
        for (var _i = 0, event_1 = event_2; _i < event_1.length; _i++) {
            var key = event_1[_i];
            var item = JSON.parse(events[service][key]);
            if (item) {
                item.key = key;
                list[key] = item;
            }
        }
    }
    return Object.keys(list).sort().reverse().map(function (key) {
        return list[key];
    });
}
